import { resolveDomainsForRoute } from 'store/domains/utils'

const namespacesForDomains = (coreNamespaces, domainToI18nNamespaces, domains) => {
  const extra = domains.flatMap((domain) => domainToI18nNamespaces[domain] ?? [])
  return [...new Set([...coreNamespaces, ...extra])]
}

export const createRouteNamespaces = (coreNamespaces, domainToI18nNamespaces) => (routeKey = '', pathname) => {
  const domains = resolveDomainsForRoute(pathname, routeKey)
  if (!domains.length) {
    return coreNamespaces
  }
  return namespacesForDomains(coreNamespaces, domainToI18nNamespaces, domains)
}
